module.exports = __webpack_public_path__ + "static/media/IPVS.20faaecc.png";